import { render } from "./ModalCancelEditSuppliuersGroup.vue?vue&type=template&id=67d0d7a9"
import script from "./ModalCancelEditSuppliuersGroup.vue?vue&type=script&lang=js"
export * from "./ModalCancelEditSuppliuersGroup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__